import Swiper from "swiper";
import { Pagination } from "swiper/modules";

export function initNewsTeaser() {
    const newsTeasers = document.querySelectorAll(".pul-news-teaser .swiper");

    if (newsTeasers.length > 0) {
        for (const newsTeaser of newsTeasers) {
            const slider = new Swiper(newsTeaser, {
                modules: [Pagination],
                loop: true,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15,
                spaceBetween: 16,
                slidesPerView: 1.33,
                pagination: {
                    el: ".swiper-pagination"
                },
                dragMinThreshold: {
                    mouse: 0,
                    touch: 10,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1.5
                    },
                    768: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3,
                        loop: false,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                    1200: {
                        loop: false,
                        slidesPerView: 3,
                        spaceBetween: 95,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                }
            });
        }
    }
}